// extracted by mini-css-extract-plugin
module.exports = {"container":"SessionLayout_container__1ByOO"};